import { TValuationTabStep } from "../../../../domain/codecs/formIO/ListingValuationTabFormIO";
import {
    TListingValuationActionFormIO,
    TListingValuationActionName,
    TValuationEditableFact,
} from "../../../../domain/codecs/formIO/ListingValuationActionFormIO";

export const STEP_LABELS: Record<TValuationTabStep["step"], string> = {
    resolve_address: "Address resolved",
    chimnie: "Chimnie facts",
    propertydata_comps: "PropertyData comps",
    rightmove_comps: "Rightmove comps",
    compute_valuation: "Valuation computed",
};

export const runnableSteps = (steps: Array<TValuationTabStep>): Array<TValuationTabStep> =>
    steps.filter((step) => step.status !== "skipped");

export const succeededSteps = (steps: Array<TValuationTabStep>): Array<TValuationTabStep> =>
    steps.filter((step) => step.status === "succeeded");

export const MISSING_LABELS: Record<TValuationTabStep["step"], string> = {
    resolve_address: "the property's address details",
    chimnie: "property facts",
    propertydata_comps: "comparable sales from PropertyData",
    rightmove_comps: "comparable sales from Rightmove",
    compute_valuation: "the price calculation",
};

export type TPropertyClass = "flat" | "house" | "unknown";

export const propertyClass = (propertyType: string | null): TPropertyClass => {
    if (propertyType === null) return "unknown";
    const value = propertyType.toLowerCase();
    if (["flat", "maisonette", "apartment"].some((word) => value.includes(word))) return "flat";
    if (["house", "terrace", "detached", "bungalow", "cottage"].some((word) => value.includes(word))) return "house";
    return "unknown";
};

export type TValuationActionExtra = Partial<Pick<
    TListingValuationActionFormIO["input"],
    "amend_price_pence" | "amend_reason" | "fact_field"
>>;

export type TOnValuationAction = (
    action: TListingValuationActionName,
    extra?: TValuationActionExtra,
) => void;

export const editableFact = (field: string): TValuationEditableFact | null => {
    switch (field) {
        case "Bedrooms":
        case "Bathrooms":
        case "Floor area":
            return field;
        default:
            return null;
    }
};
